import CopyableText from '../../../CopyableTextKit';
import styles from './index.module.css';
export const JsonSchemaViewerCopyableName = (name: string) => {
  return (
    <div className={styles.propertyName}>
      <CopyableText text={name} copyText={name} />
    </div>
  );
};

export const JsonSchemaViewerName = (name: string) => {
  return <div className={styles.propertyName}>{name}</div>;
};
